<template>
  <pdl-dialog
    qaid="customization-discard-dialog"
    :visible="isCustomizeDiscardDialogOpen"
    :title="$t('projectOne.buyingZone.customization.discard')"
    :z-index="9999"
    :close-on-click-modal="false"
    @close="cancelDiscard"
  >
    <template #default>
      {{ dialogBodyText }}
    </template>
    <template #footer>
      <div class="buttons buttons--right">
        <pdl-button qaid="customization-discard-confirmation-button" primary alert @click="confirmDiscard">
          {{ $t('projectOne.buyingZone.customization.discard.confirm') }}
        </pdl-button>
        <pdl-button qaid="customization-discard-cancel-button" secondary @click="cancelDiscard">
          {{ $t('text.button.cancel') }}
        </pdl-button>
      </div>
    </template>
  </pdl-dialog>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex';
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlButton} from '@pedal/pdl-button';
import {ViewSize} from '@/constants/view-breakpoints.js';
import {scrollToElement} from '@/utils/scroll-to.js';

export default {
  name: 'CustomizationDiscardDialog',
  components: {
    PdlDialog,
    PdlButton,
  },

  computed: {
    ...mapState('bikeCustomization', ['isCustomizeDiscardDialogOpen', 'isModelChange']),
    ...mapState('familyDetails', ['modelChangeConfirmCallback', 'modelChangeCancelCallback', 'selectedModelId']),
    ...mapState('global', ['headerHeight']),
    ...mapGetters('viewSize', ['viewBreakpointIs']),

    dialogBodyText() {
      return this.isModelChange
        ? this.$t('projectOne.buyingZone.customization.changeWarning')
        : this.$t('projectOne.buyingZone.customization.unsaved');
    },
  },
  watch: {
    isCustomizeDiscardDialogOpen(val) {
      this.setIsDialogOpen(val);
    },
  },
  methods: {
    ...mapMutations('bikeCustomization', [
      'setCustomizeDiscardDialog',
      'setSelections',
      'setIsModelChange',
      'setIsDialogOpen',
    ]),
    ...mapMutations('productDetails', ['setIsCustomizationMode']),
    ...mapMutations('familyDetails', [
      'setModelChangeConfirmCallback',
      'setModelChangeCancelCallback',
      'setSelectedModelId',
    ]),

    confirmDiscard() {
      this.setSelections([]);
      this.setIsCustomizationMode(false);
      this.modelChangeConfirmCallback();
      if (this.viewBreakpointIs(ViewSize.SMALL) || this.viewBreakpointIs(ViewSize.MEDIUM)) {
        scrollToElement('#product-attributes', this.headerHeight);
      } else {
        scrollToElement('#family-details-center-right-slot', this.headerHeight);
      }
      this.closeDialog();
    },

    cancelDiscard() {
      this.modelChangeCancelCallback();
      this.closeDialog();
    },
    closeDialog() {
      this.setModelChangeConfirmCallback(() => {});
      this.setModelChangeCancelCallback(() => {});
      this.setIsModelChange(false);
      this.setCustomizeDiscardDialog(false);
    },
  },
};
</script>
